
<template>
    <div class="position-relative">
        <slot></slot>
    </div>
</template>

<script>
    import autoComplete from '@tarekraafat/autocomplete.js';

    export default {
        data: function () {
            return {

            };
        },
        props: ["shippingAddressModel"],
        mounted: function () {
            var vm = this;

            const autoCompleteJS = new autoComplete({
                selector: "#Address1",
                data: {
                    src: async () => {
                        // Loading placeholder text
                        document.querySelector("#Address1").setAttribute("placeholder", "טוען...");
                        // Fetch External Data Source
                        const source = await fetch('https://data.gov.il/api/3/action/datastore_search?q=' +
                            ('{"שם_ישוב":"\'' + document.querySelector("#City").value + '\':*"' + ',"שם_רחוב":"\'' + document.querySelector("#Address1").value + '\':*"}') +
                            '&resource_id=9ad3862c-8391-4b2f-84a4-2d4c68625f4b&limit=10&plain=false');
                        const data = await source.json();
                        // Post Loading placeholder text
                        document.querySelector("#Address1").setAttribute("placeholder", autoCompleteJS.placeHolder);
                        // Returns Fetched data
                        return data.result.records;
                    },
                    keys: ["שם_רחוב"],
                    key: ["#Address1"],
                    //cache: true,
                },
                searchEngine: "loose",
                placeHolder: "",
                maxResults: 5,
                highlight: true,
                debounce: 300,
                threshold: 0,
            });

            document.querySelector("#Address1").addEventListener("selection", function (event) {
                console.log(event.detail);
                vm.$props.shippingAddressModel.address1 = event.detail.selection.value["שם_רחוב"].trim().replace(")", "))").replace("(", ")").replace("))", "(");
            });
        },
        methods: {

        },
        computed: {

        }
    }
</script>